<template>
	<VOverlay
		:hasBackground="false"
		:hasJsonButton="false"
		:hasCloseButton="false"
		:closeOnBackgroundClick="false"
		:isLarge="true"
		:isVCentered="false"
		:hasFullwidthBody="true"
		:hasScrollableContent="true"
		v-model="overlayIsActive"
		:title="$t('sb.scriptList.title')"
		:useFocusTrap="false"
		:closeWithEscape="false"
	>
		<Suspense>
			<ScriptList />
		</Suspense>
	</VOverlay>
</template>

<script>
import ScriptList from '@modules/ScriptBuilder/materials/structures/ScriptList.vue';

export default {
	name: 'TheScriptOverview',
	components: {
		ScriptList,
	},
	data: function () {
		return {
			overlayIsActive: true,
		};
	},
};
</script>
